import type { NuxtAppOptions, Plugin } from '@nuxt/types';
import type VueI18n from 'vue-i18n/types';

type RuntimeNuxtAppOptions = Omit<NuxtAppOptions, 'i18n'> & {
  i18n?: typeof VueI18n.prototype;
};

// widen `myApp` to include an optional `i18n` property with runtime methods
// (e.g. `$t`, `$tc`) since Nuxt plugins may attach vue-i18n instances.
export let myApp: RuntimeNuxtAppOptions | undefined;

const globalAppContextPlugin: Plugin = ({ app }) => {
  myApp = app as RuntimeNuxtAppOptions;
};

export default globalAppContextPlugin;
